import styled from "styled-components";

// 나중에 미디어 쿼리 theme 로 빼고 768px 처리하기
export const MakerPageWrapper = styled.section`
  display: flex;
  flex: 1;
  width: 100%;
  min-height: 1000px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;
